// Main layout components
export { default as DashboardCompanyPage } from './views/DashboardCompanyPage.vue';

